import { a as _inherits, b as _createClass, c as _classCallCheck, d as _callSuper, e as _defineProperty } from './_rollupPluginBabelHelpers-047e4aae.js';
import React from 'react';
import 'prop-types';
import 'react-dom';
import './_rollupPluginBabelHelpers-b9ad31fa-7ae21c08.js';
import 'styled-components';
import './withTooltip-92e0dfed.js';
import '@styled-system/space';
import '@styled-system/color';
import '@styled-system/border';
import '@styled-system/variant';
import '@styled-system/typography';
import { I as Icon } from './index-28a062d6-3659b895.js';
import { s as styleInject } from './style-inject.es-1f59c1d0.js';

var css_248z = ".NoChromeCheck_noChrome__2gIpB {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: #F5F5F5;\n  background-image: url(\"https://s3-ap-southeast-1.amazonaws.com/haptikappimg/content/sdk-background.png\");\n  background-size: 256px;\n  z-index: 1000000000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: auto; }\n  .NoChromeCheck_noChromeBody__22HEt {\n    padding: 24px;\n    background-color: #fff;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n    text-align: center;\n    animation: NoChromeCheck_lift-up__2QxFE 0.4s cubic-bezier(0.165, 0.84, 0.44, 1); }\n    .NoChromeCheck_noChromeBodyIcon__2CHB5 {\n      width: 64px;\n      height: 64px;\n      margin: 0 auto;\n      margin-bottom: 14px; }\n      .NoChromeCheck_noChromeBodyIcon__2CHB5 svg {\n        width: 100%;\n        height: 100%; }\n    .NoChromeCheck_noChromeBodyTitle__1b8nQ {\n      font-size: 24px;\n      font-weight: 600;\n      color: #333;\n      margin-bottom: 8px; }\n    .NoChromeCheck_noChromeBodyDescription__1kuyR {\n      color: #666;\n      max-width: 600px;\n      font-size: 14px; }\n    .NoChromeCheck_noChromeBody__22HEt a {\n      display: inline-flex;\n      align-items: center;\n      border: 1px solid #EEE;\n      border-radius: 8px;\n      padding: 8px;\n      color: #666;\n      transition: 0.2s ease-out;\n      margin-bottom: 4px; }\n      .NoChromeCheck_noChromeBody__22HEt a img {\n        display: block;\n        width: 32px;\n        height: 32px;\n        object-fit: contain;\n        margin-right: 4px; }\n      .NoChromeCheck_noChromeBody__22HEt a:hover {\n        color: #2DACF0;\n        border-color: #2DACF0; }\n    .NoChromeCheck_noChromeBody__22HEt span {\n      text-decoration: underline;\n      color: #666;\n      opacity: 0.5;\n      font-size: 12px;\n      cursor: pointer; }\n\n@keyframes NoChromeCheck_lift-up__2QxFE {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 30px, 0); }\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0); } }\n";
var styles = {"noChrome":"NoChromeCheck_noChrome__2gIpB","noChromeBody":"NoChromeCheck_noChromeBody__22HEt","lift-up":"NoChromeCheck_lift-up__2QxFE","noChromeBodyIcon":"NoChromeCheck_noChromeBodyIcon__2CHB5","noChromeBodyTitle":"NoChromeCheck_noChromeBodyTitle__1b8nQ","noChromeBodyDescription":"NoChromeCheck_noChromeBodyDescription__1kuyR"};
styleInject(css_248z);

var NoChromeCheck = /*#__PURE__*/function (_React$Component) {
  function NoChromeCheck() {
    var _this;
    _classCallCheck(this, NoChromeCheck);
    _this = _callSuper(this, NoChromeCheck);
    _defineProperty(_this, "dismiss", function () {
      _this.setState({
        dismissed: true
      });
      sessionStorage.setItem("no-chrome-dismissed", "true");
    });
    _defineProperty(_this, "isChromeDesktop", function () {
      var ua = navigator.userAgent;
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {
        return false;
      }
      if (/Chrome/i.test(ua)) return true;
      return false;
    });
    _this.state = {
      dismissed: !!sessionStorage.getItem("no-chrome-dismissed")
    };
    return _this;
  }
  _inherits(NoChromeCheck, _React$Component);
  return _createClass(NoChromeCheck, [{
    key: "render",
    value: function render() {
      if (this.isChromeDesktop() || this.state.dismissed) return null;
      return /*#__PURE__*/React.createElement("div", {
        className: styles.noChrome
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.noChromeBody
      }, /*#__PURE__*/React.createElement(Icon, {
        className: styles.noChromeBodyIcon,
        src: "haptik"
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.noChromeBodyTitle
      }, "You're using an unsupported browser"), /*#__PURE__*/React.createElement("div", {
        className: styles.noChromeBodyDescription
      }, "Old browsers don't work with newer features. For an optimum experience, please switch to Google Chrome.", /*#__PURE__*/React.createElement("br", null), " ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
        href: "https://www.google.com/chrome/"
      }, /*#__PURE__*/React.createElement("img", {
        alt: "chrome_logo"
        // eslint-disable-next-line max-len
        ,
        src: "https://cdnjs.cloudflare.com/ajax/libs/browser-logos/50.0.1/archive/chrome_12-48/chrome_12-48_128x128.png"
      }), "Download Chrome"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
        role: "presentation",
        onClick: this.dismiss
      }, "or continue anyways"))));
    }
  }]);
}(React.Component);
NoChromeCheck.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "dismiss",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "isChromeDesktop",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }],
  "displayName": "NoChromeCheck"
};

export default NoChromeCheck;
